<template>
  <Flex class="show-msg" v-show="isShow" @click="close">
    <component :is="as" :class="['stamp', { getted: isGet }]">
      <div class="par">
        <p>活动名称：</p>
        <p>活动地点：</p>
        <p>活动时间：</p>
        <p>活动状态：</p>
        <p>活动类型：</p>
        <p>个人姓名：</p>
        <p>电话号码：</p>
        <p>活动内容：</p>
      </div>
      <div class="copy">
        <p>{{i.projectName}}</p>
        <p>{{i.activePlace}}</p>
        <p>{{i.startTime}} 至 {{i.endTime}}</p>
        <p>{{i.activeStatus}}</p>
        <p>{{i.activeType}}</p>
        <p>{{i.name}}</p>
        <p>{{i.phone}}</p>
        <p>{{i.activeContent}}</p>
      </div>
      <i></i>
    </component>
  </Flex>
</template>

<script>
import Flex from '@/components/Flex'

export default {
  name: 'Coupon',
  components: { Flex },
  props: {
    i: Object,
    isShow: Boolean,
    content: String,
    as: { type: String, default: 'div' }
  },
  setup: (p, c) => ({ close: _ => c.emit('close') })
}
</script>

<style lang="scss" scoped>
$blue: #50ADD3;
$yellow: #F39B00;
$pink: #D24161;
$green: #7EAB1E;
$gray: gray;

.stamp * {
  padding: 0;
  margin: 0;
  list-style:none;
  font-family:"Microsoft YaHei", 'Source Code Pro', Menlo, Consolas, Monaco, monospace;
}
.stamp {
  width: 328px;
  height: 300px;
  padding: 0 10px;
  position: relative;
  overflow: hidden;
  background-size: 15px 15px;
  background-position: 9px 3px;
  border-radius: 10px;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 10px;
    right: 10px;
    z-index: -1;
  }
  &:nth-child(n) {
    background-color: $blue;
    &::before { background-color: $blue; }
  }
  &:nth-child(2n) {
    background-color: $yellow;
    &::before { background-color: $yellow; }
  }
  &:nth-child(3n) {
    background-color: $yellow;
    /* background-color: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, $pink 5px); */
    &::before { background-color: $pink; }
  }
  &:nth-child(4n) {
    background-color: $green;
    /* background-color: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, $green 5px); */
    &::before { background-color: $green; }
  }
  &.getted {
    background-color: $gray;
    /* background-image: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, $gray 5px); */
    &::before { background-color: $gray; }
  }
  i {
    position: absolute;
    left: 20%;
    top: 45px;
    height: 190px;
    width: 390px;
    transform: rotate(-30deg);
    background-color: rgba(255, 255, 255, .15);
  }
  .par {
    height: 300px;
    float: left;
    padding: 16px 0 16px 15px;
    width: 90px;
    border-right: 2px dashed rgba(255, 255, 255, .4);
    text-align: left;
  }
  span {
    font-size: 30px;
    color: #fff;
    margin-right: 5px;
    line-height: 65px;
  }
  p {
    color: #fff;
    font-size: 16px;
    line-height: 2;
  }
  .sign {
    font-size: 30px;
  }
  sub {
    position: relative;
    color: rgba(255, 255, 255, .8);
  }
  .copy {
    display: inline-block;
    padding: 16px 0;
    width: 221px;
    vertical-align: text-bottom;
    font-size: 30px;
    color: rgb(255,255,255);
    text-align: center;
    line-height: initial;
  }
}
.get {
  font-size: 22px;
  line-height: 3.3;
}
.show-msg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 10px;
  color: white;
  background: rgba(0, 0, 0, .7);
}
</style>
